import routes from "./routes";

const webase = {
    model: {
        auth_token: '',
        user_id: null,
        currentUser: {
            id: null,
            name: '',
            email: '',
            image: '',
            referral_code: ''
        },
        currentCollaboratorId: null,
        showAccountModal: false,
        showSubscriptionModal: false,
        isCustomDomain: false,
        app: {
            id: null,
            name: '',
            icon_class: '',
            theme_color: '',
            description: '',
            details: '',
            default_app_permission_id: '',
            default_data_permission_id: '',
            permission: 'full',
            publish_as_template: false,
            hide_tab_navigation: false,
            tables: [],
            website_id: null,
            collaborators: [],
            nft_collections: [],
            user_app_uuid: -1,
            user_data_uuid: -1,
            wlc: false,
            whitelabel_config: null,
            theme_id: null
        },
        currentTable: {
            id: '',
            name: '',
            fields: []
        },
        website: {
            id: '',
            name: '',
            slug: '',
            ga_tracking_id: '',
            app_id: null,
            webpages: [],
            metadata: {
                textFont: 'Raleway',
                headerFont: 'Montserrat',
                netlifySiteId: '',
                tagManagerId: ''
            }
        },
        viewModel: {
            renderType: 'Mobile'
        },
        supportMobile: false,
        apps: [],
        appTemplates: [],
        websiteTemplates: [],
        websites: [],
        documents: [],
        permissions: [],
        icons: [],
        iconsByCategory: {},
        ionIcons: [],
        fonts: [],
        themes: [],
        theme: null,
        isMobile: false,
        loading: false,
        fieldOptions: [
            '', 'String', 'Text', 'Number', 'Boolean', 'Date', 'Single Select', 'Link to Object', 'Collaborator',
            'URL', 'Attachment', 'Dynamic', 'Image'
        ],
        clipboard: null,
        viewTypeOptions: [
            'grid', 'list', 'gallery', 'kanban', 'form', 'custom', 'details'
        ],
        componentTypes: [
            'Label', 'Header', 'Button', 'Icon', 'Link', 'Image', 'Video', 'Text', 'Container', 'Row'
        ],
        actions: [
            'save', 'back', 'link'
        ],
        defaultColors: ['#7B64FF', '#FE9200', '#009CE0',
            '#68BC00', '#F44E3B','#FCC400'],
        iconOptions: ['book', 'bullhorn', 'bullseye', 'cubes', 'comment', 'cog', 'cloud', 'clock', 'diagram', 'heart', 'lightbulb', 'tasks',
            'rocket', 'robot', 'smile', 'trophy', 'university', 'users'],
        availableIcons: {
            book: 'fas fa-book',
            heart: 'fas fa-heart',
            bullhorn: 'fas fa-bullhorn',
            bullseye: 'fas fa-bullseye',
            tasks: 'fas fa-tasks',
            diagram: 'fas fa-project-diagram',
            users: 'fas fa-users',
            cubes: 'fas fa-cubes',
            comment: 'fas fa-comment',
            cloud: 'fas fa-cloud',
            clock: 'fas fa-clock',
            cog: 'fas fa-cog',
            lightbulb: 'fas fa-lightbulb',
            rocket: 'fas fa-rocket',
            robot: 'fas fa-robot',
            smile: 'fas fa-smile',
            trophy: 'fas fa-trophy',
            university: 'fas fa-university'
        },
        justifyOptions: [
            'left', 'center', 'right', 'between'
        ],
        alignOptions: [
            'top', 'middle', 'bottom'
        ],
        emojiCategories: {},
        siteConfig: {
            name: '',
            logo_url: '',
            app_id: null,
            host_domain: ''
        }
    },
    utils: {
        array: {},
        user: {
            isAdmin() {},
            isAdminOrOwner() {},
            isCustomer() {},
            isDealCustomer() {}
        },
        table: {},
        layout: {},
        app: {},
        font: {},
        theme: {},
        color: {}
    },
    managers: {
        app: null,
        permission: null,
        state: null
    },
    services: {
        view: null,
        app: null
    },
    factory: {
        blockchain: null
    },
    unsplash: {}
}

export default webase